import { StudentContactType } from "./student-contact-type";

export class StudentContact {

    constructor(
        public email: string,
        public phoneNumber: string,
        public mobileNumber: string,
        public type: StudentContactType,
        public name: string,
        public id?: number
    ){}
}
